import styled from 'styled-components';

const customColors = {
  greyMedium: '#C0CBD9',
  greyDark: '#9BAABD',
  greyLight: '#EDEFF2',
  fontLight: '#929FB0',
};

const { greyMedium, greyDark, fontLight, greyLight } = customColors;

export const FooterStyle = styled.div`
  .mainHead {
    font-weight: 600;
    font-size: 16px;
    text-transform: uppercase;
    letter-spacing: 0.16em;
    color: ${greyMedium};
  }
  .borderBottom {
    padding-bottom: 8px;
    border-bottom: 0.5px solid ${greyDark};
  }
  .borderTop {
    border-top: 0.5px solid ${greyDark};
  }
  .subHead {
    font-weight: 600;
    font-size: 16px;
    color: ${greyMedium};
    margin-top: 32px;
    margin-bottom: 14px;
  }
  .sectionHead {
    font-weight: 600;
    font-size: 16px;
    color: ${greyMedium};
    margin-bottom: 14px;
  }
  .list-width {
    max-width: fit-content;
    @media (max-width: 768px) {
      width: 100%;
    }
  }
  .list {
    font-weight: 400;
    font-size: 14px;
    color: ${fontLight};
    margin-bottom: 8px;
    cursor: pointer;
  }
  .list:hover {
    text-decoration-line: underline;
    color: #ffffff;
    font-weight: 600;
  }
  .buttonList {
    font-weight: 400;
    font-size: 14px;
    color: ${greyLight};
    background: rgba(146, 159, 176, 0.3);
    opacity: 0.6;
    border: 0.5px solid ${greyMedium};
    border-radius: 4px;
    padding: 0px 12px;
    width: auto;
    cursor: pointer;
  }
  .buttonList:hover {
    opacity: 1;
    font-weight: 600;
    color: #314259;
    background: rgba(255, 255, 255, 0.9);
    border: 0.5px solid rgba(255, 255, 255, 0.8);
  }
  .greyMedium {
    color: ${greyMedium};
  }
  .fontLight {
    color: ${fontLight};
  }
  .background_color {
    background: '#151515';
  }
  .background_color_international {
    background-color: #050520;
  }
  .rtl {
    direction: rtl;
  }
`;
